import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.css';
import DateRangePicker from 'components/shared/DateRangePicker';
import MobileContext from 'context/MobileContext';
const Header = ({ loadHistory, limit, startDate, endDate, setStartDate, setEndDate }) => {
  const isMobile = useContext(MobileContext);
  return (
    <div className={styles.container}>
      {isMobile ? <div className={styles.divider} /> : null}
      <h1 className={styles.heading}>Check-ins</h1>
      <div className={styles.pickHistoryDate}>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          loadHistory={loadHistory}
          limit={limit}
        />
      </div>
    </div>
  );
};
Header.propTypes = {
  loadHistory: PropTypes.func.isRequired,
  resetHistory: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  changeParentState: PropTypes.func.isRequired,
  loadHistoryPDF: PropTypes.func.isRequired,
  setUsed: PropTypes.func.isRequired,
  idCA: PropTypes.string.isRequired,
  startDate: PropTypes.object.isRequired,
  visits: PropTypes.object.isRequired,
};

export default Header;
